// D:\my-website\src\firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
// 如果您还使用了其他Firebase服务，例如认证：
// import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAfY0BYuEjHDJlOLdeWXeO1q6PAYX4_y-U",         // <--- 从Firebase控制台复制
  authDomain: "theglobalscm-site.firebaseapp.com", // <--- 从Firebase控制台复制
  projectId: "theglobalscm-site",   // <--- 从Firebase控制台复制
  storageBucket: "theglobalscm-site.firebasestorage.app",
  messagingSenderId: "7522119660",
  appId: "1:75221196600:web:1436916c08655d2dc2ebcd"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
// 如果您需要 Auth 服务：
// export const auth = getAuth(app);

console.log("Firebase initialized successfully from src/firebase.js");